/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAModelBuilderLoadFiltersQueryVariables = {||};
export type PGAModelBuilderLoadFiltersQueryResponse = {|
  +pgaTourGetSavedModelFilters: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
  |}>
|};
export type PGAModelBuilderLoadFiltersQuery = {|
  variables: PGAModelBuilderLoadFiltersQueryVariables,
  response: PGAModelBuilderLoadFiltersQueryResponse,
|};
*/


/*
query PGAModelBuilderLoadFiltersQuery {
  pgaTourGetSavedModelFilters {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PGATourSavedModelFilterType",
    "kind": "LinkedField",
    "name": "pgaTourGetSavedModelFilters",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderLoadFiltersQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PGAModelBuilderLoadFiltersQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "36153fdb50b6cb1ebfa7daa6089dd6d4",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderLoadFiltersQuery",
    "operationKind": "query",
    "text": "query PGAModelBuilderLoadFiltersQuery {\n  pgaTourGetSavedModelFilters {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6cb563385bbb21d9cafe663fa4f9de9d';

module.exports = node;
